import React from 'react';

const newsItems = [
  {
    date: '27 novembre 2025',
    title: 'Nouvelle fonctionnalité : compteur externe des auditeurs en ligne',
    paragraphs: [
      'Nous avons ajouté une nouvelle possibilité pour les radios : un compteur externe des auditeurs en ligne que vous pouvez intégrer sur n’importe quel site, widget ou lecteur.',
      'La connexion est très simple : dans le cabinet, sur la page Live Service, cliquez sur le bouton « Obtenir le compteur externe » et le système vous enverra automatiquement un lien personnel par e-mail.',
      'Le compteur s’intègre dans n’importe quel design, car il renvoie uniquement la valeur numérique des auditeurs et vous gardez entièrement la partie visuelle.',
      'La fonctionnalité est déjà disponible pour tous les utilisateurs.'
    ]
  },
  {
    date: '24 novembre 2025',
    title: 'TOP : service de classement musical mis à jour pour les radios',
    paragraphs: [
      'Nous avons mis à jour le service de classement musical — il s’appelle désormais TOP.',
      'Ce qui change et s’améliore :',
      'Uniquement des titres musicaux. TOP compte seulement les chansons réellement diffusées, les statistiques reflètent donc fidèlement la rotation musicale.',
      'Classement à taille flexible. Chaque station peut choisir le ranking dont elle a besoin : TOP-10, TOP-20, TOP-40, TOP-50, TOP-100 — ou toute autre valeur dans cet intervalle. C’est pratique pour la programmation interne ainsi que pour les rapports destinés aux ayants droit et aux annonceurs.',
      'Exports alignés sur le TOP-N choisi. La taille sélectionnée s’applique automatiquement aux exports : téléchargez le PDF ou l’Excel avec le même TOP-N qu’à l’écran.',
      'TOP est déjà disponible dans l’espace radio — choisissez le mois, définissez la taille voulue du classement et générez le rapport.',
      'Pour utiliser TOP, l’export des playlists de la station est requis.'
    ]
  },
  {
    date: '20 novembre 2025',
    title: 'Nouvelle métrique dans Radiomonitor : Average Daily Reach (ADR)',
    paragraphs: [
      'Nous avons ajouté à Radiomonitor la métrique Average Daily Reach (ADR), qui montre combien d’auditeurs uniques visitent votre station sur la période choisie (1 jour, 7 jours, 1 mois, etc.).',
      'ADR aide à voir la véritable portée de la station pour la période sélectionnée, à comprendre combien d’auditeurs vous attirez réellement et à dialoguer avec annonceurs et partenaires avec un chiffre de reach clair et crédible.',
      'La métrique ADR est utile aux propriétaires de stations, directeurs commerciaux, directeurs des programmes et marketeurs qui gèrent des campagnes publicitaires et le développement de la station.'
    ]
  },
  {
    date: '13 novembre 2025',
    title: 'Nouvel agent HTTPS — les IP réelles des auditeurs via une connexion sécurisée',
    paragraphs: [
      'Nous avons créé un agent HTTPS dédié pour les stations qui diffusent via le protocole sécurisé HTTPS. Il lit les adresses IP réelles des auditeurs sur le serveur web (OpenResty/Nginx ou tout autre journal de connexions), les combine avec les données Icecast et envoie à Radiomonitor des statistiques déjà "nettoyées".',
      "L'agent fonctionne dans un conteneur Docker séparé côté station, n'a aucun accès aux services internes de Radiomonitor et ne transmet aucun secret externe. Tous les paramètres — identifiants, ID de station, chemins vers les journaux et Icecast — restent uniquement dans le fichier de configuration local.",
      'Ainsi les flux HTTPS bénéficient de la même précision de comptage que les flux HTTP classiques : IP réelles fiables, état des sessions à jour et géoanalyse correcte pour chaque auditeur.',
      "Nous rappelons qu'un agent HTTP est également disponible pour simplifier la connexion et l'envoi de statistiques vers notre serveur."
    ]
  },
  {
    date: '17 octobre 2025',
    title: "Nouveau service AHA — profil d'écoute moyen par jour",
    paragraphs: [
      "Nous avons ajouté le service AHA (Average Hourly Audience) qui construit un profil d'écoute par jour de la semaine et montre comment l'audience moyenne évolue heure par heure.",
      'Pour chaque jour (du lundi au dimanche), le système calcule un effectif horaire moyen en agrégeant toutes les dates correspondantes dans la période choisie.',
      "L'interface propose à la fois un graphique et un tableau en carte thermique."
    ]
  },
  {
    date: '16 octobre 2025',
    title: 'Mise à jour méthodologique dans "Pics de charge"',
    paragraphs: [
      'Nous avons révisé la méthode de calcul du service "Pics de charge" (section Statistiques).',
      'Les périodes "semaine" et "mois" mettent désormais en avant la valeur maximale de connexions simultanées.'
    ]
  },
  {
    date: '15 février 2025',
    title: 'Le nouveau cabinet statistique est en ligne',
    paragraphs: [
      "Nous avons entièrement refait le \"cabinet utilisateur\". Les indicateurs clés sont regroupés par blocs et se chargent instantanément grâce aux requêtes optimisées.",
      "L'interface est adaptée aux tablettes, ce qui permet à vos équipes de suivre les métriques en temps réel même en déplacement."
    ]
  },
  {
    date: '28 janvier 2025',
    title: 'La surveillance du silence gagne en précision',
    paragraphs: [
      "Nous avons ajouté un calibrage automatique des niveaux sonores pour chaque flux. Le système analyse l'historique de la station et ajuste les seuils de déclenchement sans réglages manuels.",
      "Un nouveau rapport avec marqueurs indique l'horodatage, la durée et la source de l'incident pour accélérer l'analyse."
    ]
  },
  {
    date: '10 décembre 2024',
    title: 'Lancement bêta des notifications push',
    paragraphs: [
      "L'équipe support a activé les notifications push dans le navigateur pour les événements de statistiques et de flux. La fonctionnalité est en bêta et nécessite une activation dans le cabinet.",
      'Nous serions ravis de recevoir vos retours — écrivez-nous à support@radiomonitor.net.'
    ]
  }
];

export default function NewsPageFr({ onSubscribeClick }) {
  return (
    <div
      style={{
        maxWidth: 880,
        margin: '0 auto',
        padding: '40px 24px 80px',
        lineHeight: 1.6,
        color: '#1b1b1f'
      }}
    >
      <h1 style={{ marginBottom: 24, color: '#006e45' }}>Actualités Radiomonitor.net</h1>
      <div
        style={{
          marginBottom: 32,
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: 16
        }}
      >
        <p style={{ margin: 0, flex: '1 1 320px', lineHeight: 1.6 }}>
          Nous partageons ici les mises à jour de la plateforme, les améliorations de services et la feuille de route à court terme.
        </p>
        <button
          type="button"
          onClick={() => onSubscribeClick?.()}
          style={{
            padding: '12px 20px',
            borderRadius: 12,
            border: 'none',
            background: '#006e45',
            color: '#fff',
            fontSize: 16,
            fontWeight: 700,
            cursor: 'pointer',
            flex: '0 0 auto'
          }}
        >
          S'abonner aux actualités
        </button>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 28 }}>
        {newsItems.map((item) => (
          <article key={item.title}>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#4a7f6b', textTransform: 'uppercase' }}>
              {item.date}
            </div>
            <h2 style={{ margin: '8px 0 16px', color: '#134b37', fontSize: 24 }}>
              {item.title}
            </h2>
            {item.paragraphs.map((text, idx) => (
              <p key={idx} style={{ marginBottom: 16 }}>
                {text}
              </p>
            ))}
          </article>
        ))}
      </div>
    </div>
  );
}
